import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../components/AsyncComponent';

const ApiKeysSetting = asyncComponent(() =>
  import('../../../containers/authorised/setting/apiKeys/ApiKeysSetting')
)

const apiKeysRoutes = (
  <Switch>
    <Route exact path="/settings/api-keys" component={ApiKeysSetting} />
  </Switch>
);

export default apiKeysRoutes;